import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './composedMail.module.scss';
import DisplayActorEmails from './../displayActorEmails';
import getLabel from './../../../../utils/labels'
import mailArrow from '../../../../globals/images/mailarrow.svg';
import sortBy from 'lodash/sortBy';

class ComposedMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isArrowDown: true
        }
    }

    // componentDidMount() {
    //     if (!this.props.tutorial.isRunning) {
    //         this.props.startTutorial()
    //     }
    // }

    getComposeBody = (actionThread) => {
        const composeBody = actionThread.find((action) => action.type === "compose");
    }

    getPreText = (replyMailOptions) => {
        if (replyMailOptions.preText) {
            return replyMailOptions.preText.map((para, key) => <div className={styles.pretext} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    }

    getGreetingText = (composeBody) => {
        return <div className={styles.salutaion}>{getLabel('label_greetings_initial')} {this.getFirstNamesOfActors(composeBody)},</div>
    };

    getSelfActor = () => {
        const { selfActor, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === selfActor) || actors.inActors.find(actor => actor.id === selfActor);
        if (actorDetails) {
            return actorDetails
        }
        return selfActor;
    }

    getEmailSignature = () => {
        const selfActor = this.getSelfActor();
        return (
            <div
                style={{
                    margin: '10px 0',
                    lineHeight: '22px'
                }}
            >
                {getLabel('label_regards')},<br />{selfActor.first_name} {selfActor.last_name}<br />{selfActor.role}<br />{selfActor.company}
            </div>
        )
    }

    getPostText = (replyMailOptions) => {
        if (replyMailOptions.postText) {
            return replyMailOptions.postText.map((para, key) => <div className={styles.thanks} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    };

    getMessageArrangedList = (optionsToDisplay, optionsItems, id) => {
        // console.log(optionsToDisplay, optionsItems, "arranged list");
        const list = optionsToDisplay.map((itemId, key) => {
            const itemText = optionsItems.find((option) => option.id === itemId);
            // console.log("notFound", optionsToDisplay, optionsItems);
            return <div key={key} dangerouslySetInnerHTML={{ __html: itemText.text }} />;
        });
        return <div className={styles.list} key={id}>
            {list}
        </div>;
    }

    getMultipleMessageOption = (optionsToDisplay, optionsData, id) => {
        const list = optionsToDisplay.map((itemId, key) => {
            const itemText = optionsData.options.find((option) => option.id === itemId);
            // console.log("notFound", optionsToDisplay, optionsItems);
            return <div key={key} dangerouslySetInnerHTML={{ __html: itemText.text }} />;
        });
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.getPreText(optionsData)}
            <div className={styles.list} key={id}>
                {list}
            </div>
            {this.getPostText(optionsData)}
        </div>;
    }

    getMessageSelectedOption = (optionId, optionsData) => {
        const itemText = optionsData.options.find((option) => option.id === optionId);
        // console.log("notFound", optionsToDisplay, optionsItems);
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.getPreText(optionsData)}
            <p className={styles.singleOptionStyle} key={optionId} dangerouslySetInnerHTML={{ __html: itemText.text }} />
            {this.getPostText(optionsData)}
        </div>
    }

    getBody = (body, rol) => {
        const sortedBody = sortBy(body, ['messageGroupId']);
        return sortedBody.map((item, index) => {
            const currentMessage = rol.find((message) => message.id === item.messageGroupId);

            if (currentMessage.type === "mcq") {
                return this.getMessageSelectedOption(item.optionId, currentMessage);
            } else if (currentMessage.type === "multiple") {
                return this.getMultipleMessageOption(item.choosenOptions, currentMessage, index)
            } else {
                return this.getMessageArrangedList(item.sequence, currentMessage, index);
            }

            // if (currentMessage.isMessageSelctor) {
            //     return this.getMessageSelectedOption(item, currentMessage);
            // }
        })

    }

    getFromActor = () => {
        const { from, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
        if (actorDetails) {
            return actorDetails.first_name + ' ' + actorDetails.last_name
        }
        return from;
    }

    getToActors = (composeBody, returnArray = false) => {
        const { actors } = this.props;
        let { to, cc } = composeBody;
        let temp, actorArray = [];
        to = [...to, ...cc];

        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)
                if (temp) {
                    actorArray.push(temp.first_name + ' ' + temp.last_name)
                } else {
                    return actorArray.push(toActor);
                }

                if (cc.includes(toActor)) {
                    return { type: 'cc', details: temp }
                } else {
                    return { type: 'to', details: temp }
                }
            })

            if (returnArray) {
                return actorDetails
            }

            return actorArray.join(", ");
        }
    }

    getFirstNamesOfActors = (composeBody) => {
        let array = this.getToActors(composeBody, true);
        let actorNames = []
        if (array.length >= 2) {
            return getLabel('label_all_text')
        } else {
            array.map(item => {
                if (item.details.is_group_email === 0) {
                    actorNames.push(item.details.first_name)
                } else {
                    actorNames.push(getLabel('label_all_text'))
                }
            })
            return actorNames.join(", ");
        }
    }

    getSelfActor = () => {
        const { actors, selfActor } = this.props;
        return actors.inActors.find(actor => actor.id === selfActor)
    }

    toggleArrow = () => {
        this.setState(prevState => ({
            isArrowDown: !prevState.isArrowDown
        }))
    }

    getEmailOfAllActors = (composeBody) => {
        return this.getToActors(composeBody, true);
    }

    render() {
        const { replyMailOptions, actionThread, currentTime, isHovered, currentActorId } = this.props;

        let { isArrowDown } = this.state;
        let arrowStyle = {
            transform: 'rotate(180deg)',
            marginTop: '-5px'
        }

        const composeBody = actionThread && actionThread.find((action) => action.type === "compose");

        let displayTime = Math.floor((composeBody.actionTakenAt - currentTime) / 60);
        if (!(displayTime > 0)) {
            displayTime = 0;
        }

        let selfActor = this.getSelfActor();
        return (<div className={styles.container}>
            <div className={styles['icon-container']}>
                <img src={selfActor.gravatar} className={styles.image} />
            </div>
            <div className={styles['content']}>
                <header className={styles['header']}>
                    <div className={styles["people-container"]} >

                        <div
                            className={styles['from']}
                            style={{ position: 'relative' }}
                            onMouseEnter={() => this.props.setIsHoveredFlag(selfActor.id)}
                            onMouseLeave={() => this.props.removeIsHoveredFlag()}
                            data-tip="React-tooltip"
                        >
                            {`${selfActor.first_name} ${selfActor.last_name}`}
                            {
                                isHovered && selfActor.id === currentActorId ?
                                    this.props.getActorDetailsOnHover(selfActor)
                                    :
                                    null
                            }
                        </div>

                        <div className={styles['to-list']}>
                            <p>{getLabel('label_to_actors_list')}</p>
                            <p style={{ marginLeft: '4px' }}>{this.getToActors(composeBody)}</p>
                            <div
                                className={styles.arrow}
                                onClick={this.toggleArrow}
                            >
                                <img src={mailArrow} style={!isArrowDown ? arrowStyle : {}} />
                                {
                                    !isArrowDown ?
                                        <DisplayActorEmails data={this.getEmailOfAllActors(composeBody)} />
                                        :
                                        null
                                }
                            </div>
                        </div>

                    </div>

                    <div className={styles['action-list']}>
                        <div className={styles.timer}>
                            {
                                displayTime > 0 ?
                                    <div>{("0" + displayTime).slice(-2)} {getLabel('label_time_received_at')}</div>
                                    :
                                    <div>{getLabel('label_just_now')}</div>
                            }
                        </div>
                    </div>
                </header>
                <div className={styles.body}>
                    {this.getGreetingText(composeBody)}
                    {/* {this.getPreText(replyMailOptions)} */}
                    {this.getBody(composeBody.body, replyMailOptions.rol)}
                    {/* {this.getPostText(replyMailOptions)} */}
                    {this.getEmailSignature()}
                </div>
                {/* {this.getAttachment()} */}
            </div>

        </div>)
    }
}

ComposedMail.propTypes = {}

ComposedMail.defaultProps = {};

export default ComposedMail;



// WEBPACK FOOTER //
// /src/components/mailThread/mail/composedMail/ComposedMail.js